import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, MenuItem } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CVHttpService } from '../../services';

const proficiencyLevels = [
    'Native',
    'Fluent',
    'Advanced',
    'Intermediate',
    'Basic',
    'Beginner'
];

function LanguageFormDialog({ open, onClose, onSave, cvId, language }) {
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: language || {
            title: '',
            proficiency: ''
        }
    });

    useEffect(() => {
        if (open) {
            if (language) {
                reset({
                    title: language.title || '',
                    proficiency: language.proficiency || ''
                });
            } else {
                reset({
                    title: '',
                    proficiency: ''
                });
            }
        }
    }, [language, open, reset]);

    const onSubmit = async (data) => {
        try {
            const body = {
                ...data,
                id: language?.id || null,
                cv: cvId,
                user: null
            };
            await CVHttpService.saveLanguage(body);
            onSave();
        } catch (err) {
            alert('Failed to save language');
            console.error(err);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>{language ? 'Edit Language' : 'Add Language'}</DialogTitle>
                <DialogContent>
                    <Stack spacing={3} sx={{ mt: 1 }}>
                        <TextField
                            fullWidth
                            label="Language *"
                            {...register('title', { required: 'Language name is required' })}
                            error={!!errors.title}
                            helperText={errors.title?.message}
                            placeholder="e.g., English, Spanish, French"
                        />
                        <TextField
                            fullWidth
                            select
                            label="Proficiency Level"
                            {...register('proficiency')}
                            defaultValue={language?.proficiency || ''}
                        >
                            {proficiencyLevels.map((level) => (
                                <MenuItem key={level} value={level}>
                                    {level}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="submit" variant="contained">Save</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default LanguageFormDialog;

